import "./App.css";
import { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import Startup from "./Components/Startup";
import WordLimit from "./Components/WordLimit";
import MoodTracker from "./Components/MoodTracker";
import Navbar from "./Components/Navbar";
import Main from "./Components/Main";
import GoalHit from "./Components/GoalHit";
import PromptData from "./PromptData";

function App() {
  const [showStartup, setShowStartup] = useState(true); //make it true at the end
  const [wordLim, setWordLim] = useState(
    JSON.parse(localStorage.getItem("wordLimit")) || 50
  );
  const [newUser, setNewUser] = useState(
    localStorage.getItem("newUser")
      ? JSON.parse(localStorage.getItem("newUser"))
      : true
  );
  const [userMoodDataArr, setUserMoodDataArr] = useState(
    JSON.parse(localStorage.getItem("userMoodData")) || []
  );
  const [journalIn, setJournalIn] = useState("");
  const [journalDataArr, setJournalDataArr] = useState(
    JSON.parse(localStorage.getItem("journalData")) || []
  );
  const [wordsCount, setWordsCount] = useState(0);
  const [entrySaved, setEntrySaved] = useState(false);
  // const [totalWordsToday, setTotalWordsToday] = useState(0);
  const [goalIsHit, setGoalIsHit] = useState(false);

  const d = new Date();
  const [moodIsSet, setMoodIsSet] = useState(false);
  const promptArr = PromptData.data.prompts;
  const [prompt, setPrompt] = useState(
    promptArr[Math.floor(Math.random() * promptArr.length)].prompt
  );
  const [promptState, setPromptState] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowStartup(false);
    }, 2500);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const lastDataIndex = userMoodDataArr.length - 1;
    const lastData = userMoodDataArr[lastDataIndex];
    const d = new Date();

    //if the user has not logged in the same day again, then ask for their mood
    if (
      lastDataIndex > -1 &&
      lastData.date === d.getDate() &&
      lastData.month === d.getMonth() + 1 &&
      lastData.year === d.getFullYear()
    ) {
      setMoodIsSet(true);
    } else {
      setMoodIsSet(false);
    }
  }, [userMoodDataArr]);

  useEffect(() => {
    const wordsCountArr = journalIn
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .split(/\s+/)
      .filter(Boolean);

    setWordsCount(wordsCountArr.length);
  }, [journalIn]);

  useEffect(() => {
    if (entrySaved && wordsCount >= wordLim) {
      setGoalIsHit(true);
    } else {
      setGoalIsHit(false);
    }
  }, [wordsCount, entrySaved, wordLim]);

  function handleWordLimInputChange(event) {
    setWordLim(event.target.value);
  }

  function handleWordLimClick() {
    localStorage.setItem("wordLimit", JSON.stringify(wordLim));
    localStorage.setItem("newUser", JSON.stringify(false));
    setNewUser(false);
  }

  function handleMoodClick(emojiId) {
    const newDataObj = {
      id: emojiId,
      date: d.getDate(),
      month: d.getMonth() + 1,
      year: d.getFullYear(),
    };
    const copyArr = userMoodDataArr;
    copyArr.push(newDataObj);
    localStorage.setItem("userMoodData", JSON.stringify(copyArr));
    setUserMoodDataArr((prevArr) => [...prevArr, newDataObj]);
  }

  function handleJournalInputChange(event) {
    setJournalIn(event.target.value);
  }

  function handleJournalSaveClick(journalEntry, wordsCount) {
    const newDataObj = {
      id: nanoid(),
      date: d.getDate(),
      month: d.getMonth() + 1,
      year: d.getFullYear(),
      entry: journalEntry,
      wordsCount: wordsCount,
    };
    const copyArr = journalDataArr;
    copyArr.push(newDataObj);
    localStorage.setItem("journalData", JSON.stringify(copyArr));
    setJournalDataArr((prevArr) => [...prevArr, newDataObj]);
    setEntrySaved(true);
  }

  function handleJournalClrClick(event) {
    event.target.value = "";
    setJournalIn("");
  }

  function handleJournalEditClick() {
    setEntrySaved(false);
  }

  function randomPrompt() {
    const randInd = Math.floor(Math.random() * promptArr.length);
    setPrompt(promptArr[randInd].prompt);
  }

  function promptToggle() {
    setPromptState((prevState) => !prevState);
  }

  return (
    <div className="App">
      {showStartup ? (
        <Startup />
      ) : newUser === true ? (
        <WordLimit
          wordLim={wordLim}
          handleChange={handleWordLimInputChange}
          handleClick={handleWordLimClick}
        />
      ) : !moodIsSet ? (
        <MoodTracker handleClick={handleMoodClick} />
      ) : !goalIsHit ? (
        <>
          <Navbar wordLim={wordLim} wordsCount={wordsCount} />
          <Main
            wordLim={wordLim}
            wordsCount={wordsCount}
            journalIn={journalIn}
            handleChange={handleJournalInputChange}
            handleSaveClick={handleJournalSaveClick}
            handleClrClick={handleJournalClrClick}
            handleEditClick={handleJournalEditClick}
            entrySaved={entrySaved}
            prompt={prompt}
            randomPrompt={randomPrompt}
            promptState={promptState}
            promptToggle={promptToggle}
          />
        </>
      ) : (
        <GoalHit />
      )}
    </div>
  );
}

export default App;
